import { ApplicationArrayIcon } from './ApplicationArrayIcon';

/**
 * author: Michael Irigoyen
 * id B5216901-ECCB-41B3-8F35-BFA701ECDDBC
 * name application-array
 * version: 4.3.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/application-array.svg
 * tags
 * - Developer / Languages 
 */
export const IframeArrayIcon = ApplicationArrayIcon;
export default IframeArrayIcon